<template>
    <div>
        <VHeader></VHeader>
        <NewKeeBreadcrumb class="kee-b"></NewKeeBreadcrumb>
        <div class="wl-container-my-favourite">
            <div class="course-content" v-loading="loading">
                <el-tabs v-model="activeName" @tab-click="onSizeChange(8)" class="kee-tabs">
                    <el-tab-pane :label="$t('myFafourite')" name="myCollect"></el-tab-pane>
                    <el-tab-pane :label="$t('myCourses')" name="myCourse"></el-tab-pane>
                </el-tabs>
                <div class="search-content">
                    <el-input :placeholder="$t('please_input')" v-model="searchInput">
                        <el-button slot="append" icon="el-icon-search" type="primary" @click="getTable">{{
                            $t('btn_search2')
                        }}</el-button>
                    </el-input>
                </div>
                <div class="course-list" v-if="courseList.length">
                    <div class="course-item-outer" v-for="item in courseList" :key="item.courseId">
                        <div class="course-item" @click="goDetail(item)">
                            <div :class="['isNew', $i18n.locale === 'en' ? '__en' : '']" v-if="item.newCourseFlag"></div>
                            <img :src="item.coverImgUrl" alt="" class="course-pic" />
                            <div class="title-row">
                                <el-tooltip :content="item.title" :disabled="item.title.length <= 24">
                                    <div class="course-title">
                                        {{ item.title }}
                                    </div>
                                </el-tooltip>
                            </div>
                            <div class="course-price">
                                <el-tag :type="item.form === 'ONLINE' ? 'success' : 'danger'" size="mini"
                                  :style="[item.form === 'ONLINE' ? {'background': '#1E49E20F','color': '#1E49E2'} : {'margin-left': '0'}]">
                                    {{ item.form === 'ONLINE' ? $t('courseInfo_online') : $t('courseInfo_offline') }}
                                </el-tag>
                                <el-tag :type="item.chargeType === 'FREE' ? 'success' : 'danger'" size="mini"
                                  :style="[item.chargeType === 'FREE' ? {'margin-left': '10px','background': '#1E49E20F','color': '#1E49E2'} : {'margin-left': '10px'}]">
                                  {{ item.chargeType === 'FREE' ? $t('kee_free') : $t('kee_charge') }}
                                </el-tag>
                            </div>
                            <div class="course-item-child">
                                <div class="course-time" v-show="item.form === 'ONLINE'">
                                    {{ $t('kee_duration') }}: {{ durationTrans(item.sumDurationFormat) }}
                                </div>
                                <div :class="['course-collect', getUser.userType == '2' ? '' : 'course-collect-kp']"
                                    @click.stop="removeCollect(item)">
                                    <img src="@/assets/img/icon-collect.svg" v-if="item.collectFlag"
                                        class="collect-icon" width="100%" />
                                    <!-- <span>{{ $t('kee_like') }}</span> -->
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <el-empty class="course-list" v-else
                    :description="activeName == 'myCollect' ? $t('kee_my_empty') : $t('kee_my_empty1')"></el-empty>
                <el-pagination class="wl-pagination" :current-page="pagination.pageNum" :page-size="pagination.pageSize"
                    @size-change="onSizeChange" @current-change="onCurrentPageChange" :page-sizes="[8, 16, 24, 48, 96]"
                    layout="prev, pager, next, sizes, total" :total="pagination.total">
                </el-pagination>
            </div>
        </div>
        <vBottom></vBottom>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
import API from '@/api'
import Tooltip from '@/components/common/Tooltip.vue'
import VHeader from '@/components/common/Header.vue'
import VBottom from '@/components/common/Bottom'
import NewKeeBreadcrumb from './NewKeeBreadcrumb.vue'

export default {
    name: 'myCourseNew',
    components: {
        Tooltip,
        VHeader,
        VBottom,
        NewKeeBreadcrumb
    },
    data() {
        return {
            searchInput: '',
            activeName: 'myCollect',
            courseList: [],
            pagination: {
                pageNum: 1,
                pageSize: 8,
                total: 0
            },
            loading: false
        }
    },
    mounted() {
        this.getTable()
    },
    methods: {
        durationTrans(v) {
            return [v[0], this.$t('hour'), v[1], this.$t('minute'), v[2], this.$t('second')].join(' ')
        },
        getTable() {
            this.loading = true
            let param = {
                fuzzy: this.searchInput,
                pageNum: this.pagination.pageNum,
                pageSize: this.pagination.pageSize
            }
            if (this.activeName === 'myCourse') {
                param.viewFlag = 1
            } else {
                param.collectFlag = 1
            }
            API.insights.queryCourseInfo(param).then((res) => {
                if (res.code === '1') {
                    this.courseList = res.data.records || []
                    this.pagination.total = res.data.total
                } else {
                    this.$message.error(this.$t(res.code))
                }
                this.loading = false
            })
        },
        goDetail(item) {
            if (item.status == 'WITHDRAW') {
                // 已下架的课程不让点进详情页
                this.$message.error($t('kee_offline_detail_disabled'))
                return
            }
            this.$router.push({ name: 'courseDetailNew', query: { courseId: item.courseId } })
        },
        removeCollect(item) {
            let param = {
                courseId: item.courseId,
                flag: 0
            }
            API.insights.updateCollectFlagRecord(param).then((res) => {
                if (res.code === '1') {
                    this.$message.success(this.$t('msg_success'))
                    this.getTable()
                } else {
                    this.$message.error(this.$t(res.code))
                }
                this.loading = false
            })
        },
        onCurrentPageChange(current) {
            this.pagination.pageNum = current
            this.getTable()
        },
        onSizeChange(current) {
            this.pagination.pageNum = 1
            this.pagination.pageSize = current
            this.getTable()
        }
    },
    computed: {
        ...mapGetters('common', {
            getUser: 'getUser'
        })
    }
}
</script>
<style scoped>
.wl-container-my-favourite {
    color: #444;
    height: 100%;
    margin: 0 200px;
}

.kee-b {
    margin: 0 200px;
    height: 40px;
    display: flex;
    align-items: center;
}

.course-content {
    /* height: 100%; */
    background-color: white;
    border-radius: 5px;
    position: relative;
}

.search-content {
    position: absolute;
    display: flex;
    right: 0;
    top: 7px;
}

.kee-tabs .el-tabs__header {
  padding: 0 !important;
}

::v-deep .el-input-group>.el-input__inner {
    height: 28px;
}

::v-deep .el-input-group__append button.el-button {
    border-color: #3879eb;
    background-color: #3879eb;
    color: white;
    height: 28px;
}

.wl-green-small {
    height: 28px;
    margin-left: 10px;
}

.course-list {
    /* padding: 15PX 20PX;
    height: calc(100% - 30PX - 48px);
    overflow: auto; */
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    width: 100%;
    margin-top: 10px;
    /* height: calc(100% - 95PX); */
}

.course-list.el-empty {
    flex-direction: column;
}

.course-list .course-item-outer {
    width: calc(25% - 20px);
    /* height: 500PX; */
    margin: 10px;
}

.course-list .course-item-outer .course-item {
    height: 100%;
    padding: 15px;
    border-radius: 5px;
    position: relative;
    cursor: pointer;
    transition: all 0.3s linear;
    box-shadow: 0 0 10px #e6e6e6;
}

.course-list .course-item-outer .course-item .course-pic {
    width: 100%;
    height: 200px;
    object-fit: cover;
    border-radius: 5px;

}

.course-list .course-item-outer .course-item:hover {
    box-shadow: 1px 1px 8px 8px #efeff5;
}

.course-list .course-item-outer .course-item .isNew {
    display: inline-block;
    position: absolute;
    background: url("~@/assets/img/kpicon-new-6.png") center center/100% 100% no-repeat;
    width: 60PX;
    height: 30PX;
    right: -15PX;
    top: -10PX;
}

.course-list .course-item-outer .course-item .isNew.__en {
  width: 45PX;
  height: 25PX;
  background: url("~@/assets/img/kpicon-new-3.png") center center/100% 100% no-repeat;
}


.course-list .course-item-outer .course-item .title-row {
    width: 100%;
    font-size: 12px;
    font-weight: 600;
    margin-top: 5px;
    /* display: flex;
    flex-direction: row;
    justify-content: center; */
    /* height: 100px; */
}

.course-list .course-item-outer .course-item .course-price {
    margin-top: 10px;
    font-size: 12px;
}

.course-list .course-item-outer .course-item .course-item-child {
    width: 100%;
    display: flex;
    justify-content: space-between;
    margin-top: 10px;
}

.course-list .course-item-outer .course-item .course-item-child .course-collect {
    display: flex;
    flex-direction: column;
}

.course-list-item {
    padding: 20px;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    position: relative;
    overflow: hidden;
    margin: auto;
    margin-bottom: 20px;
    height: 600px;
}

.course-list-item:hover {
    background-color: rgba(0, 0, 0, 0.1);
    transition: all 1s;
}

.wl-pagination {
    padding-right: 20px !important;
}
</style>
